module.exports = __webpack_public_path__ + "img/logo-simplyhealth-white.46ed4079.png";